import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import PageHero from '@/components/feature/PageHero';
import { achievements } from '@/mocks/home';
import { fetchAchievementList } from '@/services/achievement';
import { adaptAchievements } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import type { AchievementItem } from '@/types/content';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Modern%20research%20laboratory%20with%20herbal%20extract%20bottles%20and%20a%20large%20data%20visualization%20screen%2C%20warm%20amber%20and%20teal%20accents%2C%20soft%20cinematic%20lighting%2C%20dark%20lower%20area%20for%20text%20overlay%2C%20professional%20editorial%20photography&width=1920&height=560&seq=achievements-hero&orientation=landscape';

export default function AchievementsPage() {
  // 接口失败时降级为 mock 数据
  const { data: achievementList } = useRequest<AchievementItem[]>(
    () => fetchAchievementList({ pageIndex: 1, pageSize: 999 }).then((res) => adaptAchievements(res.list)),
    { fallback: achievements },
  );

  return (
    <PageShell>
      <PageHero
        image={HERO_IMAGE}
        eyebrow="成果转化"
        title="让科研成果，走向临床应用"
        description="记录平台在数智中医、中西医结合与经验传承方向的成果转化进展，推动科研创新真正服务临床与产业。"
        breadcrumb={[{ label: '首页', to: '/' }, { label: '成果转化' }]}
      />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
            {achievementList.map((item) => (
              <Link
                key={item.id}
                to={`/achievements/${item.id}`}
                className="group flex flex-col sm:flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full sm:w-2/5 h-44 sm:h-auto overflow-hidden shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 成果转化`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col flex-1 p-5">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 mb-2">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                  <h3 className="font-heading font-semibold text-base text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.summary}
                  </p>
                  <span className="mt-auto pt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                    查看详情
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}